import React from "react";
import { SENTIMENT_COLORS } from "./constants";
import { SENTIMENT_SHAPES } from "./glyph-shapes";
import { normalizeSentiment } from "./normalizeSentiment";

interface SentimentGlyphProps {
  /** Any stored spelling — normalized here. Renders nothing when unrated. */
  sentiment: string | null | undefined;
  size?: number;
  /** Overrides the rating's own colour. Rarely wanted. */
  color?: string;
  /** Set when the glyph carries meaning no adjacent text already states. */
  title?: string;
}

/**
 * One rating glyph, no chrome — for chips, badges and metric rows. Drawn solid
 * (no outline), so it matches the *selected* state of the Hat's rating buttons.
 */
export const SentimentGlyph = ({
  sentiment,
  size = 24,
  color,
  title,
}: SentimentGlyphProps) => {
  const key = normalizeSentiment(sentiment);
  if (!key) return null;

  const { viewBox, Shape } = SENTIMENT_SHAPES[key];
  const fill = color ?? SENTIMENT_COLORS[key].glyph;

  return (
    <svg
      width={size}
      height={size}
      viewBox={viewBox}
      fill="none"
      role={title ? "img" : "presentation"}
      aria-hidden={title ? undefined : true}
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: "block", flexShrink: 0 }}
    >
      {title && <title>{title}</title>}
      <Shape fill={fill} stroke={fill} strokeWidth={0} />
    </svg>
  );
};
